import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";

import { ELocalStorageKeys } from "@/constants/local-storage-keys.constant";

export const useConfigurationStore = defineStore("configurationStore", () => {
  const clientTimezone = useLocalStorage(
    ELocalStorageKeys.CONFIGURATION_CLIENT_TIMEZOME,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  function updateClientTimezone(timezone: string): void {
    clientTimezone.value = timezone;
  }

  return {
    clientTimezone,
    updateClientTimezone,
  };
});
